import { createAction, props } from '@ngrx/store';

export const loadCompanyLogo = createAction('[CompanyLogo/API] Load Company Logo');

export const loadCompanyLogoSuccess = createAction(
  '[CompanyLogo/API] Load Company Logo Success',
  props<{ url: string }>()
);

export const loadCompanyLogoFailure = createAction(
  '[CompanyLogo/API] Load Company Logo Failure',
  props<{ error: any }>()
);

export const updateCompanyLogo = createAction('[CompanyLogo/API] Update CompanyLogo', props<{ payload: string }>());

export const updateCompanyLogoSuccess = createAction(
  '[CompanyLogo/API] Update Company Logo Success',
  props<{ url: string }>()
);

export const updateCompanyLogoFailure = createAction(
  '[CompanyLogo/API] Update Company Logo Failure',
  props<{ error: any }>()
);

export const deleteCompanyLogo = createAction('[CompanyLogo/API] Delete CompanyLogo');

export const deleteCompanyLogoSuccess = createAction('[CompanyLogo/API] Delete Company Logo Success');

export const deleteCompanyLogoFailure = createAction(
  '[CompanyLogo/API] Delete Company Logo Failure',
  props<{ error: any }>()
);

export const clearCompanyLogo = createAction('[CompanyLogo/API] Clear Company Logo');
